$(document).ready(function(){
  $(".like_icon").click(function(){
    $(this).parents(".likes").addClass("ongoing");
    var productid = $(this).parents(".likes").attr("data-productid");
    var customerid=$(this).parents(".likes").attr("data-customerid");
    $.ajax({
      type: 'POST',
      url: 'http://localhost/lovecounter/lovecounter.php?productid='+productid+'&customerid='+customerid,
      dataType: 'html',
      success:function(data,textStatus,jqXHR){
        $("#id-"+productid).removeClass("ongoing");
		//location.reload();
        console.log(data);
        var getcount = parseInt(data);
        var prev_val = $("#id-"+productid+" .likes_count").html();
        $("#id-"+productid+" .likes_count").html(getcount);
        //$(this).siblings(".likes_count").html(getcount);
        if(getcount > prev_val){
        $("#id-"+productid+" > img").attr("src","http://cdn.shopify.com/s/files/1/0228/8535/t/51/assets/like_on-15.png?753874679274770429");
        }
        else{
        $("#id-"+productid+" > img").attr("src","http://cdn.shopify.com/s/files/1/0228/8535/t/51/assets/like_off-15.png?753874679274770429");
        }
      }
    })
  })
}) 